import { useNavigate } from "react-router";
import LeftPaginationArrowIcon from "../../../../assets/icons/LeftPaginationArrowIcon";
import RightPaginationArrowIcon from "../../../../assets/icons/RightPaginationArrowIcon";
import CustomPagination from "../../../../components/CustomPagination";
import CourseItem from "../../../../components/ui/CourseItem";
import useFilters from "../../../../hooks/useFilters";
import { popularCourse } from "../../home/constants";

export default function AllPrograms() {
  const navigate = useNavigate();
  const { limit, page, handlePagination } = useFilters();

  return (
    <section className="py-20 container mini-container">
      <div className="justify-start text-neutral-800 text-2xl lg:text-3xl font-semibold">
        জনপ্রিয় কোর্স
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 mb-11">
        {popularCourse.map((el) => (
          <CourseItem
            key={el.id}
            {...el}
            onMoreButton={() => navigate(`/courses/${el.id}`)}
          />
        ))}
      </div>

      <CustomPagination
        limit={limit}
        page={page}
        total={100}
        handlePagination={handlePagination}
        prevIcon={<LeftPaginationArrowIcon />}
        nextIcon={<RightPaginationArrowIcon />}
        className="border-none"
        paginationClassName="course_pagination pt-4"
        hidePage
      />
    </section>
  );
}
